<div id="outerContainer" style="overflow: hidden; height: 100vh;">
  <div class="pdf-container" style="height: 100%; width: 100%;">
    <ng2-pdfjs-viewer
      #pdfViewer
      viewerWidth="100%"
      viewerHeight="100%"
      zoom="page-width"
      [urlValidation]="false"
      [download]="false"
      [print]="false"
      [openFile]="false"
      [showToolbarLeft]="false"
      [showToolbarMiddle]="false"
      [showToolbarRight]="false"
      [showSecondaryToolbarToggle]="false"
      [customCSS]="'#toolbarContainer { display: none !important; } #viewerContainer { top: 0 !important; } #mainContainer { background-color: #ffffff !important; } .ng2-theme-light, .ng2-theme-light-active { --ng2-default-bg: #ffffff !important; }'">
    </ng2-pdfjs-viewer>
  </div>
</div>
